import ScanContext from "./scan-context";
import useScanStorage from "../hooks/use-scan-storage";
import useScanResults from "../hooks/use-scan-results";
import useAiSuggestions from "../hooks/use-ai-suggestions";

export default function ScanContextProvider({ children }) {
	const storage = useScanStorage();
	const { upsertRecord, updateResolvedForUrl } = storage;
	const results = useScanResults({ upsertRecord, updateResolvedForUrl });
	const ai = useAiSuggestions();

	return (
		<ScanContext.Provider value={{ ...storage, ...results, ai }}>
			{children}
		</ScanContext.Provider>
	);
}
